import { render, staticRenderFns } from "./o-x4-column-text.vue?vue&type=template&id=7252430b&scoped=true"
import script from "./o-x4-column-text.vue?vue&type=script&lang=js"
export * from "./o-x4-column-text.vue?vue&type=script&lang=js"
import style0 from "./o-x4-column-text.vue?vue&type=style&index=0&id=7252430b&prod&lang=scss&scoped=true"
import style1 from "./o-x4-column-text.vue?vue&type=style&index=1&id=7252430b&prod&lang=scss"
import style2 from "./o-x4-column-text.vue?vue&type=style&index=2&id=7252430b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7252430b",
  null
  
)

export default component.exports